module.exports = __webpack_public_path__ + "static/media/heathrow-logo.15ed7d3b.png";